// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swipe-panel[data-v-0b510ea2]{display:flex;margin-right:5px;pointer-events:auto}.swipe-panel>.white[data-v-0b510ea2]{color:#fff;border-radius:20px;max-height:34px}.swipe-panel .swipe[data-v-0b510ea2]{position:absolute;bottom:0;width:100vw}", ""]);
// Exports
module.exports = exports;
